<template>
  <!-- "Extract colors from:" — the grid of toggleable extraction sources shown
       when the Settings panel is expanded. Dimmed + non-interactive while a
       generation is running. -->
  <div>
    <p :id="labelId" class="mt-2 font-semibold text-gray-200">Extract colors from:</p>
    <div
      role="group"
      :aria-labelledby="labelId"
      class="mt-4 grid grid-cols-1 gap-4 transition sm:grid-cols-2"
      :class="{ 'pointer-events-none opacity-50': disabled }"
    >
      <ExtractionOption
        v-for="option in options"
        :key="option.id"
        :option="option"
        :disabled="disabled"
        @toggle="$emit('toggle', option)"
        @slide="(value) => $emit('slide', option, value)"
      />
    </div>
  </div>
</template>

<script setup>
import { useId } from 'vue'
import ExtractionOption from '~/components/molecules/ExtractionOption.vue'

defineProps({
  options: { type: Array, required: true },
  disabled: { type: Boolean, default: false },
})
defineEmits(['toggle', 'slide'])

const labelId = useId()
</script>
